import ptPlusApiBaseUrl from '../../../api/ptPlusApiBaseUrl';
import axioPath from '../../../api/axioPath';
import { showAppLoader, hideAppLoader } from '../app';

export const ptPlusPendingRequestsApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.post(`/ptms/order/get_all_pending_order_request`, data, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data };
    return ex;
  });
};

export const ptPlusScheduledPostsApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  let dataVal = {
    size: data?.size || 10,
    number: data.currentPage,
    searchBy: data.searchText,
    fromDate: data.fromDate,
    toDate: data.toDate,
    statusList: data.filterBy,
    locations: data.locations,
    excludeCompleteOrders: data.excludeCompleted,
    sortType: data.sortType,
    sort: data.sort,
  }
  return ptPlusApiBaseUrl.post(`/ptms/order/get_all_scheduled_post_order`, dataVal, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data };
    return ex;
  });
};

export const adminFetchLocationListApi = (token) => (dispatch) => {
  return ptPlusApiBaseUrl.get('/ptms/internal/location_name_list', {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};

export const postNeedSpecApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath.post(`rfp/grade/list-pallet-deatils-grade-commodity`, data, {
    headers: {
      Authorization: token,
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data };
    return ex;
  });
};